import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from './redux/store';

import LoginPage from './pages/login/index';
import AdminPage from './pages/admin/index';
import TeacherPage from './pages/teacher/index';

import 'bootstrap/dist/css/bootstrap.min.css';
import TestingPage from './pages/testing';

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/" exact>
          <LoginPage />
        </Route>

        <Route path="/login">
          <LoginPage />
        </Route>

        <Route path="/admin">
          <AdminPage />
        </Route>

        <Route path="/teacher">
          <TeacherPage />
        </Route>

        <Route path="/testing">
          <TestingPage />
        </Route>
      </Switch>
    </BrowserRouter>
  </Provider>
);

export default App;
